/* src/app/ai-sourcing/blurbackdrop/blurbackdrop.component.scss */
.backdrop-blur {
  display: block;
  visibility: visible;
  position: relative;
  top: 0px;
  left: 0%;
  bottom: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.05);
  -webkit-backdrop-filter: blur(0px);
  backdrop-filter: blur(0px);
  z-index: 5;
  opacity: 1;
  pointer-events: none;
  background-image: url("./media/blur-image-3ERODAFJ.png");
  background-size: cover;
  background-position: left top;
  background-repeat: no-repeat;
}
.sub-modal {
  padding: 30px 15px;
  border-radius: 4px;
  z-index: 6;
  position: absolute;
  left: 50%;
  top: 45%;
  display: block;
  visibility: visible;
  opacity: 1;
  margin-top: -1px;
  transform: translate(-50%, -70%);
  width: 435px;
  height: auto;
  background-color: #ffffff;
  box-shadow: 1px 3px 20px -15px #000;
}
.card-position {
  width: 70.3%;
  top: 27%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
/*# sourceMappingURL=blurbackdrop.component-UL4SD3XS.css.map */
